// extracted by mini-css-extract-plugin
export default {"FeatureCards":"FeatureCards_FeatureCards__NxBBw"};